import { getUuid } from '@sibe/utilities/common';
import { HsGeometryType } from '../../graphic-engine-new/geometry/geometry-type.enum';
import { HsBox } from '../../math-new/shapes/box.class';
import { HsSphere } from '../../math-new/shapes/sphere.class';
import type { HsGraphics } from '../graphics.class';
import type { HsGraphicsBuffer } from '../types/graphic-buffer.type';
import { HsSpriteGeometry } from '../../graphic-engine-new/geometry/sprite-geometry.class';
import { HsBufferType } from '../enums/buffer-type.enum';

export namespace HsSpriteConstants {
  export const SPRITE_VERTICES: Float32Array = new Float32Array([-1, -1, 1, -1, 1, 1, -1, 1]);
  export const SPRITE_TEXTURE_COORDINATES: Float32Array = new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]);
  export const SPRITE_INDICES: Int32Array = new Int32Array([0, 2, 1, 0, 3, 2]);

  let spriteGeometry: HsSpriteGeometry | null = null;

  export function makeSpriteGeometry(graphics: HsGraphics): HsSpriteGeometry | null {
    const buffer: HsGraphicsBuffer | null = graphics.createBuffer(
      new Float32Array([...SPRITE_VERTICES, ...SPRITE_TEXTURE_COORDINATES])
    );
    const indexBuffer: HsGraphicsBuffer | null = graphics.createBuffer(SPRITE_INDICES, HsBufferType.elementBuffer);
    if (buffer === null || indexBuffer === null) {
      return null;
    }
    const SPRITE_BOX: HsBox = HsBox.makeFromArray(SPRITE_VERTICES);
    spriteGeometry = new HsSpriteGeometry(
      getUuid(),
      HsGeometryType.Sprite,
      SPRITE_BOX,
      HsSphere.makeSphereFromBoundingBox(SPRITE_BOX.min, SPRITE_BOX.max),
      SPRITE_VERTICES.length,
      SPRITE_INDICES.length,
      buffer,
      indexBuffer
    );
    return spriteGeometry;
  }
}
